var map = {
	"./BBC_ProjectReith_WorldNews_Tile_Red_RGB.svg": 369,
	"./BBC_ProjectReith_WorldNews_Tile_Red_RGB@2x.png": 370,
	"./BlueSocialIcon/facebook.svg": 371,
	"./BlueSocialIcon/share-icon-bg.svg": 372,
	"./BlueSocialIcon/share-icon-black.svg": 373,
	"./BlueSocialIcon/share-icon-close.svg": 374,
	"./BlueSocialIcon/share-icon-open.svg": 375,
	"./BlueSocialIcon/share-icon.svg": 376,
	"./BlueSocialIcon/twitter.svg": 377
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 368;